import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const CookieConsent: React.FC = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            // Show banner after a short delay for better UX
            setTimeout(() => setShowBanner(true), 1000);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        setShowBanner(false);
    };

    const handleReject = () => {
        localStorage.setItem('cookie-consent', 'rejected');
        setShowBanner(false);
        // Clear any existing auth tokens if user rejects
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('nickname');
        localStorage.removeItem('nickname_required');
        localStorage.removeItem('date_joined');
        localStorage.removeItem('auth_source');
    };

    if (!showBanner) return null;

    return (
        <div className="fixed bottom-16 left-0 right-0 z-50 bg-gray-900/95 backdrop-blur-sm border-t border-accent/50 shadow-lg">
            <div className="max-w-7xl mx-auto px-4 py-2">
                <p className="text-xs sm:text-sm text-text-secondary text-center leading-relaxed">
                    This site uses cookies to provide essential functionality. By continuing to use this site, you accept our{' '}
                    <a href="/privacy" className="text-accent hover:text-accent/80 underline">Privacy Policy</a>
                    {' '}and{' '}
                    <a href="/terms" className="text-accent hover:text-accent/80 underline">Terms of Service</a>.
                    {' '}
                    <button
                        onClick={handleAccept}
                        className="text-accent hover:text-accent/80 underline font-semibold cursor-pointer"
                    >
                        Accept & Continue
                    </button>
                </p>
            </div>
        </div>
    );
};

export default CookieConsent;
